import {createApp} from 'vue'
import {createPinia} from 'pinia'
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'
import {definePreset} from '@primeuix/themes'
import Tooltip from 'primevue/tooltip'
import 'primeicons/primeicons.css'
import './style.css'
import App from './App.vue'
const Workshop=definePreset(Aura,{semantic:{primary:{50:'{yellow.50}',100:'{yellow.100}',200:'{yellow.200}',300:'{yellow.300}',400:'{yellow.400}',500:'{yellow.500}',600:'{yellow.600}',700:'{yellow.700}',800:'{yellow.800}',900:'{yellow.900}',950:'{yellow.950}'},colorScheme:{dark:{surface:{0:'#ffffff',50:'#f6f6f5',100:'#e9e9e6',200:'#d2d2ce',300:'#b4b6b3',400:'#90958f',500:'#686f68',600:'#4b534d',700:'#363e38',800:'#262d28',900:'#1c221e',950:'#141915'}}}}})
createApp(App).use(createPinia()).use(PrimeVue,{theme:{preset:Workshop,options:{darkModeSelector:'.dark'}}}).directive('tooltip',Tooltip).mount('#app')
